module.exports = "https://chowbus-web-static.chowbus.com/_next/static/images/download_app_reward-40acd9ce0c6800b47bfe993532058c82.png";